import { FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <>
      <div className="bg-cyan-800">
        <div className=" footer sm:footer-horizontal text-white p-8 py-10 max-w-screen-2xl mx-auto">
          <aside>
            <Link
              to="/"
              className="flex mb-4 items-center space-x-4 text-2xl font-bold "
            >
              <img
                src="/logoWhite.svg"
                alt="Logo"
                className="w-28 max-h-auto"
              />
            </Link>

            <p className="text-lg font-black">CAKRAWALA JAKARTA KREATIF</p>

            <p className="lg:max-w-3xl">
              A hub for innovation and creativity, with a long-term vision to
              create meaningful change. We are committed to developing an
              ecosystem that supports the growth of creative industries.
            </p>

            <p className="lg:max-w-2xl">
              Based in Jakarta, the business and cultural center of Indonesia,
              we continue to drive strategic collaboration to build a more
              dynamic future.
            </p>
          </aside>

          <nav className="mt-4">
            <h6 className="text-lg font-bold uppercase">Join Us</h6>
            <Link to="/Sukarelawan" className="link link-hover">
              Volunteers
            </Link>
            <Link to="/Sponsor" className="link link-hover">
              Sponsor
            </Link>
          </nav>

          <nav className="mt-4">
            <h6 className="text-lg font-bold uppercase">Information</h6>
            <Link to="/PrivacyPolicy" className="link link-hover">
              Privacy Policy
            </Link>
            <Link to="/TermsConditions" className="link link-hover">
              Terms & Conditions
            </Link>
            <Link to="/About-us" className="link link-hover">
              About Us
            </Link>
          </nav>

          <nav className="mt-4">
            <h6 className="text-lg font-bold uppercase">Follow Us</h6>
            <div className="flex flex-col items-start space-y-4">
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-white"
              >
                <FaInstagram className="text-xl mr-2" />
                <span>cakrawalajakarta</span>
              </a>
            </div>
          </nav>
        </div>
      </div>

      <footer className="footer sm:footer-horizontal footer-center bg-slate-100 text-base-content p-4">
        <aside>
          <p>
            Copyright © {new Date().getFullYear()} - All rights reserved PT.
            Cakrawala Jakarta Kreatif
          </p>
        </aside>
      </footer>
    </>
  );
};
